import { render, staticRenderFns } from "./RegisterNewClient.vue?vue&type=template&id=5a395b31&scoped=true&"
import script from "./RegisterNewClient.vue?vue&type=script&lang=js&"
export * from "./RegisterNewClient.vue?vue&type=script&lang=js&"
import style0 from "./RegisterNewClient.vue?vue&type=style&index=0&id=5a395b31&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a395b31",
  null
  
)

export default component.exports